import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Layout, PageHeader, Input, Button, Icon } from 'antd'

import ProviderPopup from '@components/Popup/ProviderPopup'
import List from './List'

@inject((store: any) => {
    const { popupStore, providerStore } = store
    return { popupStore, providerStore }
})
@observer
class Providers extends Component<any, any> {
    state = {
        providersList: [],
        filtered: []
    }

    componentDidMount() {
        this.updateList()
    }

    filterProviders = value => {
        const { providersList } = this.state
        const filtered = providersList.filter(provider => {
            return provider.name.includes(value) || provider.id.toString().includes(value)
        })
        this.setState(prevState => ({ ...prevState, filtered }))
    }

    handleAddProvider = () => {
        this.props.popupStore.togglePopup('addProvider', {})
    }

    async updateList() {
        const { getProviders } = this.props.providerStore
        const providers = (await getProviders()).data
        this.setState({ providersList: providers.list, loading: false })
        this.filterProviders('')
    }

    render() {
        const { filtered, providersList } = this.state
        return (
            <Layout>
                <PageHeader
                    onBack={() => window.history.back()}
                    title="מעסיקים בעלי פוליסות קבוצתיות"
                    subTitle={
                        providersList.length === filtered.length
                            ? `סה"כ ${filtered.length} מעסיקים`
                            : `מציג ${filtered.length} מתוך ${providersList.length} מעסיקים`
                    }
                >
                    <Button style={{ fontSize: '1rem' }} onClick={this.handleAddProvider}>
                        <Icon type="plus" /> הוספת מעסיק
                    </Button>
                    <Input.Search
                        placeholder="חיפוש על פי שם מעסיק או מזהה"
                        onChange={e => this.filterProviders(e.target.value)}
                        style={{ width: '40%', marginRight: '0.5rem' }}
                    />
                </PageHeader>
                <List list={filtered} />
                <ProviderPopup popupUpdated={() => this.updateList()} />
            </Layout>
        )
    }
}

export default Providers
